import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AcessoRouterService } from './acesso.routing.service';
import { AcessoComponent } from './index.component';

const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild([ 
    { path: 'acesso', component: AcessoComponent }
]);

@NgModule({
    imports: [routing],
    exports: [RouterModule],
    providers: [AcessoRouterService]
})
export class AcessoRoutingModule { }
